import * as Types from '../../../generated.types'

import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type OrderFormAcceptanceQueryVariables = Types.Exact<{
  ownerId: Types.Scalars['Int']
  accepterId?: Types.InputMaybe<Types.Scalars['Int']>
}>

export type OrderFormAcceptanceQuery = {
  __typename?: 'Query'
  organization?: {
    __typename?: 'Organization'
    id: number
    contractSignedOn?: string | null
    isOnboarded?: boolean | null
    acceptance?: {
      __typename?: 'Acceptance'
      id: number
      withdrawnAt?: string | null
      createdAt: string
      acceptedAt?: string | null
      formUrl?: string | null
      accepter: { __typename?: 'AcceptanceAccepter'; id: number; name: string; email: string }
      signedDocument?: { __typename?: 'File'; url?: string | null } | null
    } | null
  } | null
}

export type OrderFormAcceptanceFragment = {
  __typename?: 'Acceptance'
  id: number
  withdrawnAt?: string | null
  createdAt: string
  acceptedAt?: string | null
  formUrl?: string | null
  accepter: { __typename?: 'AcceptanceAccepter'; id: number; name: string; email: string }
  signedDocument?: { __typename?: 'File'; url?: string | null } | null
}

export const OrderFormAcceptanceFragmentDoc = `
    fragment OrderFormAcceptance on Acceptance {
  id
  withdrawnAt
  createdAt
  acceptedAt
  accepter {
    id
    name
    email
  }
  signedDocument {
    url
  }
  formUrl
}
    `
export const OrderFormAcceptanceDocument = `
    query OrderFormAcceptance($ownerId: Int!, $accepterId: Int) {
  organization(id: $ownerId) {
    id
    acceptance(type: "pth_order_form", accepterId: $accepterId) {
      ...OrderFormAcceptance
    }
    contractSignedOn
    isOnboarded
  }
}
    ${OrderFormAcceptanceFragmentDoc}`
export const useOrderFormAcceptanceQuery = <TData = OrderFormAcceptanceQuery, TError = Error>(
  variables: OrderFormAcceptanceQueryVariables,
  options?: UseQueryOptions<OrderFormAcceptanceQuery, TError, TData>
) =>
  useQuery<OrderFormAcceptanceQuery, TError, TData>(
    ['OrderFormAcceptance', variables],
    fetchGql<OrderFormAcceptanceQuery, OrderFormAcceptanceQueryVariables>(
      OrderFormAcceptanceDocument,
      variables
    ),
    options
  )

useOrderFormAcceptanceQuery.getKey = (variables: OrderFormAcceptanceQueryVariables) => [
  'OrderFormAcceptance',
  variables,
]
